import { Box, Text } from "@chakra-ui/react";

export default function SwitchComponent({ trueText, falseText, bgColor, switchStatus, setSwitchStatus }) {

    return (
        <Box
            width={['45%','35%','35%','35%','25%']}
            p='5px'
            position='relative'
            d='flex'
            style={{ fontFamily: 'Mulish, sans-serif' }}
            fontWeight='600'
            fontSize={['12px', '12px', '12px', '15px']}
            bg='white'
            border='1px solid rgba(0, 0, 0, 0.2)'
            borderRadius='lg'
            justifyContent='space-between'
            alignItems = 'center'
            onClick={() => setSwitchStatus(!switchStatus)}
            cursor='pointer'
        >
            <Text width='45%' textAlign='center' p='5px' color='#999999'>{trueText}</Text>
            <Text width='45%' textAlign='center' p='5px' color='#999999'>{falseText}</Text>
            <Box
                width='45%'
                borderRadius='lg'
                px = '5px'
                py = '7px'
                position='absolute'
                left={switchStatus ? '3px' : '53%'}
                bg={bgColor}
                color='white'
                textAlign='center'
                transition='all 200ms ease'
            >
                {switchStatus ? trueText : falseText}
            </Box>
        </Box>
    )
}